import { useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';
import { Input, TextArea, Select } from 'components';
import { withStore } from 'store';
import { useStorage64 } from 'pages/Header/Content/hooks/useStorageBase64';
import { PROFILE_DATA } from 'constants/storage64';

function StepOne({ celebrateLabels = [], shoppingCartInfo, errorMessage }) {
  const { setValues, setFieldValue, values } = useFormikContext();
  const [profileData] = useStorage64(PROFILE_DATA);
  const { giftDirected } = values;

  const hasGiftDirected = Boolean(
    _get(shoppingCartInfo, 'congrats_to_celebrated_id', '')
  );

  let nom_ap = 'Invitado ';
  useEffect(() => {
    //  console.log("profileData en StepOne: ", profileData);
     if(localStorage.getItem("guest_email") === null){
      nom_ap = `${profileData.nombre} ${profileData.apellidoP}`;
     }
    setValues({
      name: '',
      welcomeMessage: '',
      giftDirected:
         '',
    });
  }, [shoppingCartInfo, setValues]);

  useEffect(() => {
    if (celebrateLabels.length === 1 && !hasGiftDirected && !giftDirected) {
      setFieldValue('giftDirected', celebrateLabels[0].value);
    }
  }, [celebrateLabels, hasGiftDirected, giftDirected]);

  return (
    <Row>
      <Col />
      <Col xs={12} md={8} lg={7} xl={6}>
        {errorMessage && (
          <Form.Control.Feedback
            className="col-12 d-block text-center"
            type="invalid"
          >
            {errorMessage}
          </Form.Control.Feedback>
        )}
        <Input name="name" label="Tu nombre" />
        <TextArea name="welcomeMessage" label="Mensaje de felicitación" />
        <Select
          name="giftDirected"
          label="¿A quién va dirigido el regalo?"
          options={celebrateLabels}
        />
      </Col>
      <Col />
    </Row>
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    celebrateLabels: _get(
      state,
      'externalGiftTable.giftTableInfo.data.celebrate_labels',
      []
    ).map(({ label }) => ({
      label: `${label.name} ${label.value}`,
      value: label.id,
    })),
    shoppingCartInfo: _get(
      state,
      'externalGiftTable.shoppingCartInfo.data',
      {}
    ),
    errorMessage: _get(
      state,
      'externalGiftTable.updateShoppingCartInfo.errorMessage',
      {}
    ),
  }),
})(StepOne);
